module.exports = __webpack_public_path__ + "img/home.796065fa.png";